import {
  UserEnterpriseInfoViewModel,
  HomePageProxy,
  IrrigationOptimizationChartWithPlantationViewModelListResponseResult,
  IrrigationOptimizationChartWithPlantationViewModel,
  SoilMoistureBarDataViewModel,
  IrrigationRecommendationViewModel,
} from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Legend } from '../../services/weather-soil-pest/components/soil-status/soil-status.component';
import { DkSelectPlantationComponent } from '../dk-select-plantation/dk-select-plantation.component';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { WidgetInfoBoxComponent } from '../home-warnings-and-alerts/widget-info-box/widget-info-box.component';
import { PlantationService } from '@/app/core/services/plantation.service';

@Component({
  selector: 'app-home-filiz-irrigation-info',
  imports: [SharedModule, DkSelectPlantationComponent, WidgetInfoBoxComponent],
  templateUrl: './home-filiz-irrigation-info.component.html',
  styleUrl: './home-filiz-irrigation-info.component.less'
})
export class HomeFilizIrrigationInfoComponent implements OnChanges {
  @Input() selectedEnterprise: UserEnterpriseInfoViewModel;
  @Input() hasAnyDevice = false;

  @Output() readonly requestCallbackEvent = new EventEmitter<void>();

  upcomingIrrigationLoading = true;
  selectablePlantationsForFilizIrrigation: IrrigationOptimizationChartWithPlantationViewModel[] = [];
  selectedPlantationForFilizIrrigation: IrrigationOptimizationChartWithPlantationViewModel | null = null;

  statusLegends: Legend[] = [
    {
      key: 'dry',
      value: 'doktar_app.common.dry',
      color: '#C98888',
    },
    {
      key: 'opt',
      value: 'doktar_app.common.optimal',
      color: '#77C3FF',
    },
    {
      key: 'wet',
      value: 'doktar_app.common.wet',
      color: '#4DA6D8',
    },
    {
      key: 'sat',
      value: 'doktar_app.common.saturated',
      color: '#1F4E79',
    },
  ];

  fetchingError = false;

  constructor(
    private _homeProxy: HomePageProxy,
    private _router: Router,
    public plantationService: PlantationService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['selectedEnterprise']) {
      this.selectablePlantationsForFilizIrrigation = [];
      this.selectedPlantationForFilizIrrigation = null;
      if (this.selectedEnterprise && this.hasAnyDevice) {
        this.getFilizIrrigationPlantations();
      }
    }
  }

  getFilizIrrigationPlantations() {
    this.fetchingError = false;
    this.upcomingIrrigationLoading = true;
    this._homeProxy
      .homePage_GetFilizIrrigationByEnterprise(this.selectedEnterprise?.enterpriseId)
      .pipe(
        finalize(() => {
          this.upcomingIrrigationLoading = false;
        })
      )
      .subscribe((res: IrrigationOptimizationChartWithPlantationViewModelListResponseResult) => {
        if (res.isSuccess) {
          this.selectablePlantationsForFilizIrrigation = res.result?.sort((a,b) => b.date.toMillis() - a.date.toMillis()) ?? [];

          if (
            this.selectablePlantationsForFilizIrrigation?.length > 0 &&
            this.selectedPlantationForFilizIrrigation == null
          ) {
            this.selectedPlantationForFilizIrrigation = this.selectablePlantationsForFilizIrrigation[0];
          }
        } else {
          this.fetchingError = true;
        }
      });
  }

  getStatusSpecifications(item: SoilMoistureBarDataViewModel): Legend | null {
    if (item.currentValue < item.minThreshold) {
      return this.statusLegends.find((e) => e.key == 'dry');
    } else if (item.currentValue >= item.minThreshold && item.currentValue <= item.optimalMaxThreshold) {
      return this.statusLegends.find((e) => e.key == 'opt');
    } else if (item.currentValue > item.optimalMaxThreshold && item.currentValue < item.maxThreshold) {
      return this.statusLegends.find((e) => e.key == 'wet');
    } else if (item.currentValue >= item.maxThreshold) {
      return this.statusLegends.find((e) => e.key == 'sat');
    }

    return null;
  }

  getProgressBarStyles(item: SoilMoistureBarDataViewModel): any {
    const statusSpec = this.getStatusSpecifications(item);
    return {
      height: '44px',
      'border-radius': '12px',
      'background-color': '#F6F6F6',
      '--progress-bar-color': statusSpec?.color || '#AFAFAF',
    };
  }

  onSelectPlantationForFilizIrrigation(
    plantation: IrrigationOptimizationChartWithPlantationViewModel | IrrigationRecommendationViewModel
  ) {
    this.selectedPlantationForFilizIrrigation = plantation as IrrigationOptimizationChartWithPlantationViewModel;
  }

  routeToDevices() {
    this._router.navigate(['/account/devices']);
  }
}
